import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const flightApiEndPoint = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/admin/flight`;

export const getAdminFlightsListThunk = createAsyncThunk(
    "admin-flights-list",
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${flightApiEndPoint}/list`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch flight bookings" }
            )
        }
    }
)

export const getAdminFlightDetailsThunk = createAsyncThunk(
    "admin-flight-details",
    async ({ token, flightId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${flightApiEndPoint}/details/${flightId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch flight booking" }
            )
        }
    }
)
